var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1074_5459)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 84,
    height: 84,
    rx: 2.27737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 15.1172H20.1172V18.1537H23.1537V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1902 15.1172H23.1537V18.1537H26.1902V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 15.1172H26.1902V18.1537H29.2267V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 15.1172H29.2267V18.1537H32.2632V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 15.1172H32.2632V18.1537H35.2997V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 15.1172H35.2997V18.1537H38.3362V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 15.1172H38.3362V18.1537H41.3727V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 15.1172H44.4092V18.1537H47.4457V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 15.1172H56.5551V18.1537H59.5916V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 15.1172H62.6281V18.1537H65.6646V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 15.1172H65.6646V18.1537H68.7011V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 15.1172H68.7011V18.1537H71.7376V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 15.1172H71.7376V18.1537H74.7741V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 15.1172H74.7741V18.1537H77.8106V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8471 15.1172H77.8106V18.1537H80.8471V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 15.1172H80.8471V18.1537H83.8836V15.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 18.1537H20.1172V21.1902H23.1537V18.1537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 18.1537H38.3362V21.1902H41.3727V18.1537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 18.1537H47.4457L47.4457 21.1902H50.4822V18.1537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 18.1537H62.6281V21.1902H65.6646V18.1537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 18.1537H80.8471V21.1902H83.8836V18.1537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 21.1902H20.1172V24.2267H23.1537V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 21.1902H26.1902V24.2267H29.2267V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 21.1902H29.2267V24.2267H32.2632V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 21.1902H32.2632V24.2267H35.2997V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 21.1902H38.3362V24.2267H41.3727V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 21.1902H44.4092V24.2267H47.4457L47.4457 21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 21.1902H47.4457L47.4457 24.2267H50.4822V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 21.1902H50.4822V24.2267H53.5186V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 21.1902H56.5551V24.2267H59.5916V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 21.1902H62.6281V24.2267H65.6646V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 21.1902H68.7011V24.2267H71.7376V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 21.1902H71.7376V24.2267H74.7741V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 21.1902H74.7741V24.2267H77.8106V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 21.1902H80.8471V24.2267H83.8836V21.1902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 24.2267H20.1172V27.2632H23.1537V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 24.2267H26.1902V27.2632H29.2267V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 24.2267H29.2267V27.2632H32.2632V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 24.2267H32.2632V27.2632H35.2997V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 24.2267H38.3362V27.2632H41.3727V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 24.2267H44.4092V27.2632H47.4457V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 24.2267H47.4457V27.2632H50.4822V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 24.2267H53.5186L53.5186 27.2632H56.5551V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 24.2267H62.6281V27.2632H65.6646V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 24.2267H68.7011V27.2632H71.7376V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 24.2267H71.7376V27.2632H74.7741V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 24.2267H74.7741V27.2632H77.8106V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 24.2267H80.8471V27.2632H83.8836V24.2267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 27.2632H20.1172V30.2997H23.1537V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 27.2632H26.1902V30.2997H29.2267V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 27.2632H29.2267V30.2997H32.2632V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 27.2632H32.2632V30.2997H35.2997V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 27.2632H38.3362V30.2997H41.3727V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 27.2632H44.4092V30.2997H47.4457V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 27.2632H47.4457V30.2997H50.4822V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 27.2632H62.6281V30.2997H65.6646V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 27.2632H68.7011V30.2997H71.7376V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 27.2632H71.7376V30.2997H74.7741V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 27.2632H74.7741V30.2997H77.8106V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 27.2632H80.8471V30.2997H83.8836V27.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 30.2997H20.1172V33.3362H23.1537V30.2997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 30.2997H38.3362V33.3362H41.3727V30.2997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 30.2997H44.4092V33.3362H47.4457V30.2997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 30.2997H50.4822L50.4821 33.3362H53.5186V30.2997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 30.2997H56.5551V33.3362H59.5916V30.2997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 30.2997H62.6281V33.3362H65.6646V30.2997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 30.2997H80.8471V33.3362H83.8836V30.2997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 33.3362H20.1172V36.3727H23.1537V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1902 33.3362H23.1537V36.3727H26.1902V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 33.3362H26.1902V36.3727H29.2267V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 33.3362H29.2267V36.3727H32.2632V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 33.3362H32.2632V36.3727H35.2997V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 33.3362H35.2997V36.3727H38.3362V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 33.3362H38.3362V36.3727H41.3727V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 33.3362H44.4092V36.3727H47.4457V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 33.3362H50.4821V36.3727H53.5186V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 33.3362H56.5551V36.3727H59.5916V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 33.3362H62.6281V36.3727H65.6646V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 33.3362H65.6646V36.3727H68.7011V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 33.3362H68.7011V36.3727H71.7376V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 33.3362H71.7376V36.3727H74.7741V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 33.3362H74.7741V36.3727H77.8106V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8471 33.3362H77.8106V36.3727H80.8471V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 33.3362H80.8471V36.3727H83.8836V33.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4821 36.3727H47.4457L47.4457 39.4092H50.4822L50.4821 36.3727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 36.3727H50.4821L50.4822 39.4092H53.5186V36.3727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 36.3727H53.5186V39.4092H56.5551V36.3727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 39.4092H26.1902V42.4457H29.2267V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 39.4092H29.2267V42.4457H32.2632V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 39.4092H32.2632V42.4457H35.2997V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 39.4092H35.2997V42.4457H38.3362V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 39.4092H38.3362V42.4457H41.3727V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4092 39.4092H41.3727V42.4457H44.4092V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 39.4092H50.4822L50.4821 42.4457H53.5186V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 39.4092H53.5186V42.4457H56.5551V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 39.4092L56.5551 39.4092V42.4457H59.5916V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 39.4092H59.5916V42.4457H62.6281V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 39.4092H65.6646V42.4457H68.7011V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 39.4092H68.7011V42.4457H71.7376V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 39.4092H71.7376V42.4457H74.7741V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 39.4092H74.7741V42.4457H77.8106V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 39.4092H80.8471V42.4457H83.8836V39.4092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1902 42.4457L23.1537 42.4457V45.4822H26.1902V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 42.4457H32.2632V45.4822H35.2997V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 42.4457H35.2997V45.4822H38.3362V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4821 42.4457L47.4457 42.4457V45.4822H50.4822L50.4821 42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 42.4457H53.5186L53.5186 45.4822H56.5551V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 42.4457H56.5551V45.4822H59.5916V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 42.4457H62.6281V45.4822H65.6646V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 42.4457H68.7011V45.4822H71.7376V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 42.4457H71.7376V45.4822H74.7741V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 42.4457H74.7741V45.4822H77.8106V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8471 42.4457H77.8106V45.4822H80.8471V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 42.4457H80.8471V45.4822H83.8836V42.4457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 45.4822L20.1172 45.4821V48.5186H23.1537V45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1902 45.4822H23.1537V48.5186H26.1902V45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 45.4822H35.2997V48.5186H38.3362V45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 45.4821L38.3362 45.4822V48.5186H41.3727V45.4821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4092 45.4821H41.3727V48.5186H44.4092V45.4821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 45.4822L44.4092 45.4821V48.5186H47.4457L47.4457 45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 45.4822H56.5551V48.5186H59.5916V45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 45.4822H68.7011V48.5186H71.7376V45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8471 45.4822H77.8106V48.5186H80.8471V45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 45.4822H80.8471V48.5186H83.8836V45.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 48.5186H20.1172V51.5551H23.1537V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1902 48.5186H23.1537V51.5551H26.1902V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 48.5186L32.2632 48.5186V51.5551H35.2997V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4092 48.5186H41.3727V51.5551H44.4092V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 48.5186H50.4821V51.5551H53.5186V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 48.5186H56.5551V51.5551H59.5916V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 48.5186L59.5916 48.5186V51.5551H62.6281V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 48.5186L65.6646 48.5186V51.5551H68.7011V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 48.5186L74.7741 48.5186V51.5551H77.8106V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 48.5186H80.8471V51.5551H83.8836V48.5186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 51.5551H32.2632V54.5916H35.2997V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 51.5551H35.2997V54.5916H38.3362V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 51.5551H38.3362V54.5916H41.3727V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4092 51.5551H41.3727V54.5916H44.4092V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 51.5551H44.4092V54.5916H47.4457V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4821 51.5551H47.4457V54.5916H50.4822L50.4821 51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 51.5551H59.5916V54.5916H62.6281V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 51.5551H62.6281V54.5916H65.6646V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 51.5551H65.6646V54.5916H68.7011V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 51.5551H68.7011V54.5916H71.7376V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 51.5551H71.7376V54.5916H74.7741V51.5551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 54.5916H50.4822L50.4821 57.6281H53.5186V54.5916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 54.5916H56.5551V57.6281H59.5916V54.5916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 54.5916H59.5916V57.6281H62.6281V54.5916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 54.5916H65.6646V57.6281H68.7011V54.5916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 54.5916H74.7741V57.6281H77.8106V54.5916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 54.5916H80.8471V57.6281H83.8836V54.5916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 57.6281H20.1172V60.6646H23.1537V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1902 57.6281H23.1537V60.6646H26.1902V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 57.6281H26.1902V60.6646H29.2267V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 57.6281H29.2267V60.6646H32.2632V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 57.6281H32.2632V60.6646H35.2997V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 57.6281H35.2997V60.6646H38.3362V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 57.6281H38.3362V60.6646H41.3727V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 57.6281H44.4092V60.6646H47.4457V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 57.6281H59.5916V60.6646H62.6281V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 57.6281H62.6281V60.6646H65.6646V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 57.6281H65.6646V60.6646H68.7011V57.6281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 60.6646H20.1172V63.7011H23.1537V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 60.6646H38.3362V63.7011H41.3727V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 60.6646H44.4092V63.7011H47.4457V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 60.6646H47.4457V63.7011H50.4822V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 60.6646H53.5186V63.7011H56.5551V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 60.6646H62.6281V63.7011H65.6646V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 60.6646H68.7011V63.7011H71.7376V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 60.6646H71.7376V63.7011H74.7741V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8471 60.6646H77.8106V63.7011H80.8471V60.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 63.7011H20.1172V66.7376H23.1537V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 63.7011H26.1902V66.7376H29.2267V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 63.7011H29.2267V66.7376H32.2632V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 63.7011H32.2632V66.7376H35.2997V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 63.7011H38.3362V66.7376H41.3727V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 63.7011H44.4092V66.7376H47.4457V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 63.7011H50.4822L50.4821 66.7376H53.5186L53.5186 63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 63.7011H53.5186L53.5186 66.7376H56.5551V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 63.7011H56.5551V66.7376H59.5916V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 63.7011H74.7741V66.7376H77.8106V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8471 63.7011H77.8106V66.7376H80.8471V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 63.7011H80.8471V66.7376H83.8836V63.7011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 66.7376H20.1172V69.7741H23.1537V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 66.7376H26.1902V69.7741H29.2267V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 66.7376H29.2267V69.7741H32.2632V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 66.7376H32.2632V69.7741H35.2997V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 66.7376H38.3362V69.7741H41.3727V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 66.7376H44.4092V69.7741H47.4457V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4821 66.7376H47.4457V69.7741H50.4822L50.4821 66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 66.7376H50.4821L50.4822 69.7741H53.5186V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 66.7376H53.5186V69.7741H56.5551V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 66.7376H56.5551V69.7741H59.5916V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 66.7376H59.5916V69.7741H62.6281V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 66.7376H62.6281V69.7741H65.6646V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 66.7376H65.6646V69.7741H68.7011V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 66.7376H68.7011V69.7741H71.7376V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 66.7376H71.7376V69.7741H74.7741V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8106 66.7376H74.7741V69.7741H77.8106V66.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 69.7741H20.1172V72.8106H23.1537V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 69.7741H26.1902V72.8106H29.2267V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 69.7741H29.2267V72.8106H32.2632V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 69.7741H32.2632V72.8106H35.2997V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 69.7741H38.3362V72.8106H41.3727V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4457 69.7741H44.4092V72.8106H47.4457V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 69.7741H47.4457V72.8106H50.4822V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 69.7741H53.5186L53.5186 72.8106H56.5551V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 69.7741H59.5916V72.8106H62.6281V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7011 69.7741H65.6646V72.8106H68.7011V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7741 69.7741H71.7376V72.8106H74.7741V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8471 69.7741H77.8106V72.8106H80.8471V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 69.7741H80.8471V72.8106H83.8836V69.7741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 72.8106H20.1172V75.8471H23.1537V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 72.8106H38.3362V75.8471H41.3727V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 72.8106H47.4457L47.4457 75.8471H50.4822V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5186 72.8106H50.4822V75.8471H53.5186L53.5186 72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 72.8106H53.5186L53.5186 75.8471H56.5551V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5916 72.8106H56.5551V75.8471H59.5916V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 72.8106H59.5916V75.8471H62.6281V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 72.8106H62.6281V75.8471H65.6646V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7376 72.8106H68.7011V75.8471H71.7376V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8836 72.8106H80.8471V75.8471H83.8836V72.8106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1537 75.8471H20.1172V78.8836H23.1537V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1902 75.8471H23.1537V78.8836H26.1902V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 75.8471H26.1902V78.8836H29.2267V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2632 75.8471H29.2267V78.8836H32.2632V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2997 75.8471H32.2632V78.8836H35.2997V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3362 75.8471H35.2997V78.8836H38.3362V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3727 75.8471H38.3362V78.8836H41.3727V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4822 75.8471H47.4457V78.8836H50.4822V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5551 75.8471H53.5186L53.5186 78.8836H56.5551V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6281 75.8471H59.5916V78.8836H62.6281V75.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0293,
    y: 44.71,
    width: 71.9708,
    height: 21.527,
    rx: 2.04795,
    fill: "url(#paint0_linear_1074_5459)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0293,
    y: 44.71,
    width: 71.9708,
    height: 4.0959,
    rx: 2.04795,
    fill: "#2F32FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1074_5459",
    x: 0,
    y: 0,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.196078 0 0 0 0 0.996078 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1074_5459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1074_5459",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_5459",
    x1: 52.0147,
    y1: 44.71,
    x2: 52.0147,
    y2: 61.3861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9798F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F32FE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QR Code.687a58eb.svg";
export { ForwardRef as ReactComponent };